import { TFunction } from 'i18next';
import VehicleConditionsStep from 'pages/tradeIn/new_components/VehicleConditions';
import VehicleInfoStep from 'pages/tradeIn/new_components/VehicleInfo';
import VehicleOptionStep from 'pages/tradeIn/new_components/VehicleOption';
import VehicleSearchStep from 'pages/tradeIn/new_components/VehicleSearch';
import { StepConfigItem } from 'sharedComponents/dynamicStepperForm/dynamicStepperFormInterface';
import StepperForm1 from './components/Step1';
import StepperForm10 from './components/Step10';
import StepperForm11 from './components/Step11';
import StepperForm13 from './components/Step13';
import StepperForm2 from './components/Step2';
import StepperForm3 from './components/Step3';
import StepperForm4 from './components/Step4';
import StepperForm5 from './components/Step5';
import StepperForm6 from './components/Step6';
import StepperForm7 from './components/Step7';
import StepperForm8 from './components/Step8';
import StepperForm9 from './components/Step9';

export const creditScoreStepConfig1 = (t: TFunction): StepConfigItem[] => {
  return [
    {
      step1: {
        component: <StepperForm1 callStepSpecificAction={true} />,
        step: 0,
      },
    },
    {
      step2: {
        component: <StepperForm2 callStepSpecificAction={true} />,
        step: 1,
        // isFooterHidden: true,
        footerNavigationProps: {
          backNavigation: true,
        },
      },
    },
    {
      step3: {
        component: <StepperForm3 callStepSpecificAction={true} />,
        step: 2,
        footerNavigationProps: {
          backNavigation: true,
          nextNavigation: false,
        },
      },
    },
    {
      step4: {
        component: <StepperForm4 callStepSpecificAction={true} />,
        step: 3,
      },
    },
    {
      step5: {
        component: <StepperForm5 callStepSpecificAction={true} />,
        step: 4,
      },
    },
    {
      step6: {
        component: <StepperForm6 callStepSpecificAction={true} />,
        step: 5,
      },
    },
    {
      step7: {
        component: <StepperForm7 callStepSpecificAction={true} />,
        step: 6,
      },
    },
    {
      step8: {
        component: <StepperForm8 callStepSpecificAction={true} />,
        step: 7,
      },
    },
    {
      step9: {
        component: <StepperForm9 callStepSpecificAction={true} />,
        step: 8,
        isHeaderHidden: true,
      },
    },
    {
      step10: {
        component: <StepperForm10 callStepSpecificAction={true} />,
        step: 9,
        isHeaderHidden: true,
      },
    },
    {
      step11: {
        component: <StepperForm11 callStepSpecificAction={true} />,
        step: 10,
        isHeaderHidden: true,
        footerNavigationProps: {
          // nextNavigation: false,
          buttonTitle: t('stepperForm.submit'),
        },
      },
    },
    // {
    //   step12: {
    //     component: <StepperForm12 callStepSpecificAction={true} />,
    //     step: 11,
    //     isHeaderHidden: true,
    //   },
    // },
    {
      step12: {
        component: <StepperForm13 callStepSpecificAction={true} />,
        step: 11,
        isHeaderHidden: true,
        footerNavigationProps: {
          // submitButtonVisibility: false,
        },
      },
    },
  ];
};

export const tradeInStepConfig = (t: TFunction): StepConfigItem[] => {
  return [
    {
      step1: {
        component: <VehicleSearchStep callStepSpecificAction={true} />,
        step: 0,
        isHeaderHidden: true,
      },
    },
    {
      step2: {
        component: <VehicleInfoStep callStepSpecificAction={true} />,
        message: t('stepperFormTradeIn.note4'),
        step: 1,
        footerNavigationProps: {
          buttonTitle: t('stepperFormTradeIn.nextVehicleOptions'),
          // backNavigation: false,
          // fullWidth: true,
        },
      },
    },
    {
      step3: {
        component: <VehicleOptionStep callStepSpecificAction={true} />,
        step: 2,
        footerNavigationProps: {
          backNavigation: true,
          buttonTitle: t('stepperFormTradeIn.nextVehicleCondition'),
        },
      },
    },
    {
      step4: {
        component: <VehicleConditionsStep callStepSpecificAction={true} />,
        step: 3,
        footerNavigationProps: {
          backNavigation: true,

          buttonTitle: t('stepperFormTradeIn.next'),
        },
      },
    },
    {
      step5: {
        component: <VehicleConditionsStep callStepSpecificAction={true} />,
        step: 4,
        footerNavigationProps: {
          backNavigation: true,

          buttonTitle: t('stepperFormTradeIn.next'),
        },
      },
    },
  ];
};
